import { canHandleChatPageContext } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';
import type { ChatSurface } from './chat-surface-mappings';

let latestSurface: ChatSurface | null = null;
let polling = false;

function notifyNativeChatContext(surface: ChatSurface): void {
  if (!canHandleChatPageContext()) return;
  sendNativeEvent({
    event: MobileWebviewEvents.CHAT_CONTEXT_CHANGED,
    source: 'purchase',
    ...surface
  });
}

export function setChatPageContext(surface: ChatSurface): void {
  latestSurface = surface;
  if (window.CarvanaChatUi?.setPageContext) {
    window.CarvanaChatUi.setPageContext(surface);
    notifyNativeChatContext(surface);
    return;
  }
  if (polling) return;
  polling = true;
  let attempts = 0;
  const timer = setInterval(() => {
    // A test environment can tear down window while this poll is still pending
    if (typeof window === 'undefined') {
      clearInterval(timer);
      polling = false;
      return;
    }
    if (window.CarvanaChatUi?.setPageContext) {
      if (latestSurface) {
        window.CarvanaChatUi.setPageContext(latestSurface);
        notifyNativeChatContext(latestSurface);
      }
    } else if (++attempts < 40) {
      return;
    }
    clearInterval(timer);
    polling = false;
  }, 200);
}
